import { Alert, Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";
import { axiosFetch } from "../../../utils/AxiosFetch";
import ExternalTrainingFilter from "./ExternalTrainingFilter";
import ExternalTrainingList from "./ExternalTrainingList";
import dummyDataList from './TraininglistDummyData.json';
import InfiniteScroll from "react-infinite-scroller";
import { StencilList } from "react-placemoulder";
import ExternalAttendeesModal from './ExternalAttendeesModal';



function MyExternalTraining() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [exTrainingList, setExternalTrainingList] = useState(dummyDataList);
    const [exLoading, setExternalLoading] = useState(true);
    const [exPageNo, setExPageNo] = useState(1);
    const [exResultsPerPage, setExResultsPerPage] = useState(6);
    const [exTitle, setExTitle] = useState("");
    const [exScrolling, setExScrolling] = useState(false);
    const [exPagination, setExPagination] = useState({});    
    const [trainingDetail, setTrainingDetail] = useState("");
    const [attendees, setAttendees] = useState([]);
    const [userIds, setUserIds] = useState("");
    const [attendeesOpen, setAttendeesOpen] = useState(false);

    useEffect(() => {
        var params = {
            "page": exPageNo,
            "resultsPerPage": exResultsPerPage,
            "title": exTitle,
        }
        fetchExternalTrainings(params);
    }, [])
    const handleExPagination = () => {
        if (exPageNo + 1 <= exPagination.totalPages) {
            setExPageNo(exPageNo + 1)
            var params = {
                "page": exPageNo + 1,
                "resultsPerPage": exResultsPerPage,
                "title": exTitle,
            }
            fetchExternalTrainings(params);
            setExScrolling(true)
        }
    }
    const fetchExternalTrainings = (params) => {
        axiosFetch({
            method: "post",
            url: `/training/external/mytrainings`,
            requestConfig: params
        })

            .then((res) => {
                if (res.status === 200) {
                    if (res.data.pagination !== undefined) {
                        setExPagination(res.data.pagination)
                        setExPageNo(res.data.pagination.page)
                    }
                    if (res.data && res.data.trainings.length > 0 && res.data.pagination && res.data.pagination.page > 1) {
                        var list = [...exTrainingList, ...res.data.trainings];
                        setExternalTrainingList(list)
                        setExScrolling(false);
                        if (res.data.pagination !== undefined) {
                            setExPagination(res.data.pagination)
                            setExPageNo(res.data.pagination.page)
                        }
                    }
                    else {
                        setExternalLoading(false)
                        setExternalTrainingList(res.data.trainings)
                        if (res.data.pagination !== undefined) {
                            setExPagination(res.data.pagination)
                            setExPageNo(res.data.pagination.page)
                        }
                    }
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err =>
                console.error(err)
            )
    }
    const onTitleFilterChange = (val) => {
        setExTitle(val);
    }
    const handleExternalFilter = (param) => {
        setExternalLoading(true);
        var params;
        if (param === 1) {
            params = {
                "page": 1,
                "resultsPerPage": exResultsPerPage,
                "title": "",
            }
        }
        else {
            params = {
                "page": 1,
                "resultsPerPage": exResultsPerPage,
                "title": exTitle,
            }
        }

        fetchExternalTrainings(params);
    }
    const getDetails = (id) => {
        axiosFetch({
            url: `/training/external/${id}`,
            method: "get",
        })
            .then((res) => {
                if (res.status === 200) {
                    setTrainingDetail(res.data)
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));

                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const getAttendees = (id) => {
        axiosFetch({
            url: `/training/external/attendees/${id}`,
            method: "get",
        })
            .then((res) => {
                if (res.status === 200) {
                    setAttendees(res.data)                   
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));

                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleAttendeesModal = (id) => {
        if (attendeesOpen) {
            setAttendeesOpen(false)
        }
        else {
            setAttendeesOpen(true);
            getAttendees(id);
            getDetails(id);
        }
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{marginTop: "15px"}}>
                    <h1 className="main-heading">My External Training</h1>
                    {exPagination && exPagination.totalRecords > 0 ?
                        <p style={{ marginLeft: "5px", marginTop: "0px", marginBottom: "0" }}>You have got {exPagination.totalRecords} trainings </p> : ""}
                </Grid>
                <Grid item xs={3}>
                    <ExternalTrainingFilter from="list"
                        onTitleFilter={onTitleFilterChange}
                        handleFilter={handleExternalFilter}
                    />
                </Grid>
                <Grid item xs={9}>
                    <Box>
                        {exLoading ?
                            <StencilList
                                length={5}
                                Component={ExternalTrainingList}
                                data={exTrainingList}
                            /> :
                            <>
                                <InfiniteScroll
                                    // dataLength={exTrainingList.length}
                                    initialLoad={false}
                                    loadMore={exScrolling === false ? handleExPagination : ""}
                                    hasMore={exPageNo <= exPagination.totalPages}
                                    threshold={500}
                                >

                                    {exTrainingList && exTrainingList.length > 0 && exTrainingList.map((trainingList) => {
                                        return <ExternalTrainingList {...trainingList} key={trainingList.id} from="mylist" handleAttendees={handleAttendeesModal}/>
                                    })}
                                </InfiniteScroll>
                                {exTrainingList && exTrainingList.length === 0 ? <Alert severity="error">No Trainings Found</Alert> : ""}
                            </>
                        }
                    </Box>
                </Grid>
            </Grid>
            <ExternalAttendeesModal open={attendeesOpen} handleAttendees={handleAttendeesModal} users={attendees} data={trainingDetail} from="mylist"/>

        </div>
    )
}
export default MyExternalTraining;